import { createTheme, ThemeProvider } from "@mui/material/styles";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { LoaderContainer } from "react-global-loader";
import loaderImage from "../src/images/loader-high.gif";
// import TidioChat from "./components/tidio-chat";
import config from "./config";
import ActivateAccount from "./pages/activate-account.page";
import Authenticate from "./pages/authenticate.page";
import BrowseByNiche from "./pages/content-engine-v2/browse-by-niche/BrowseByNiche";
import ChooseScript from "./pages/content-engine-v2/choose-script/ChooseScript";
import GenerateScripts from "./pages/content-engine-v2/generate-scripts/GenerateScripts";
import ScriptDetail from "./pages/content-engine-v2/script-detail/ScriptDetail";
import SelectContentFormat from "./pages/content-engine-v2/select-format/SelectContentFormat";
import TrendingIdeas from "./pages/content-engine-v2/trending-ideas/TrendingIdeas";
import VideoProjectDetail from "./pages/video-projects/VideoProjectDetail";
import VideoProjects from "./pages/video-projects/VideoProjects";
import CreateAccount from "./pages/create-account.page";
import QuickVideo from "./pages/quick-video/QuickVideo";
import Dashboard from "./pages/dashboard.page";
import ForgotPassword from "./pages/forgot-password.page";
import Login from "./pages/login.page";
import Logout from "./pages/logout.page";
import Library from "./pages/library.page";
import LibraryHistory from "./pages/library-history.page";
import LibraryRecent from "./pages/library-recent.page";
import LibraryViewAll from "./pages/library-view-all.page";
import TopicContents from "./pages/topic-contents.page";
import MainPage from "./pages/main.page";
import NotFound from "./pages/not-found.page";
import PasswordReset from "./pages/password-reset.page";
import PaymentStatus from "./pages/payment-status.page";
import Plans from "./pages/plans.page";
import Profile from "./pages/profile.page";
import ScheduledVideos from "./pages/scheduled-videos.page";
import Settings from "./pages/settings.page";
import ThankYou from "./pages/thank-you.page";
import VerifyCode from "./pages/verify-code.page";
import WhiteListPage from "./pages/white-list.page";
import { COLORS } from "./theme/theme.config";

const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary,
    },
  },
});

const CLIENT_ID = config.googleClientId;
const redirectHome = <Navigate to="/" replace />;

function App() {
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <div>
          <LoaderContainer opacity={0.7} backgroundColor="#000">
            <img src={loaderImage} alt="Loader" />
          </LoaderContainer>
          <ToastContainer
            position="bottom-center"
            theme="dark"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable={false}
          />
          <Router>
            <Routes>
              <Route path="/" element={<WhiteListPage />}>
                <Route path="/login" element={<Login />} />
                <Route path="/create-account" element={<CreateAccount />} />
                <Route path="/activate-account" element={<ActivateAccount />} />
                <Route path="/password-reset" element={<PasswordReset />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/google-authorization/"
                  element={<Authenticate />}
                />
                <Route path="/verify-code" element={<VerifyCode />} />
              </Route>
              <Route path="/" element={<MainPage />}>
                <Route index element={<Dashboard />} />
                <Route path="/create-template" element={redirectHome} />
                <Route path="/templates/:templateId/edit" element={redirectHome} />
                <Route path="/templates" element={redirectHome} />
                <Route path="/create-video" element={redirectHome} />
                <Route path="/video-create" element={redirectHome} />
                <Route path="/quick-video" element={<QuickVideo />} />
                <Route path="/video-configuration" element={redirectHome} />
                <Route path="/video-projects" element={<VideoProjects />} />
                <Route
                  path="/video-projects/:id"
                  element={<VideoProjectDetail />}
                />
                <Route path="/logout" element={<Logout />} />
                <Route path="/scheduled-videos" element={<ScheduledVideos />} />
                <Route path="/settings/*" element={<Settings />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/videos" element={redirectHome} />
                <Route path="/library" element={<Library />} />
                <Route path="/library/recent" element={<LibraryRecent />} />
                <Route path="/library/history" element={<LibraryHistory />} />
                <Route path="/library/topic/:topicId" element={<TopicContents />} />
                <Route path="/library/:section" element={<LibraryViewAll />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/payment-status" element={<PaymentStatus />} />
                <Route path="/content-engine" element={<GenerateScripts />} />
                <Route
                  path="/content-engine/trending-ideas"
                  element={<TrendingIdeas />}
                />
                <Route
                  path="/content-engine/browse-by-niche"
                  element={<BrowseByNiche />}
                />
                <Route
                  path="/content-engine/select-format"
                  element={<SelectContentFormat />}
                />
                <Route
                  path="/content-engine/choose-script"
                  element={<ChooseScript />}
                /> 
                <Route
                  path="/content-engine/script-detail"
                  element={<ScriptDetail />}
                />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </div>
      </ThemeProvider>
      {/* <TidioChat /> */}
    </GoogleOAuthProvider>
  );
}

export default App;
